

export function stringToDigits(testString) {
	return testString.replace( /[^0-9]/g, '');
}

export function formatVideoLength(seconds) {
	return Math.floor(seconds / 60) + ':' + secondsHolder(seconds % 60);
}

function secondsHolder(seconds) {
	return seconds < 10 ? '0' + seconds : seconds;
}


// WEBPACK FOOTER //
// ./src/utils/formatting.jsx